import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66fea48f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col p-3 g-0" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-lg-6 px-4 col-md-12 g-0" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "mb-2 d-flex align-items-center sub-heading" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Admission")
  ])
], -1 /* HOISTED */))
const _hoisted_3 = { class: "ms-4" }
const _hoisted_4 = { class: "field-title" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Does this patient have an advance care plan or a surrogate decision-maker AND able to provide legal documentation for the home health medical record? ")
const _hoisted_6 = { class: "fas fa-question-circle" }
const _hoisted_7 = { class: "form-check custom-radio" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexRadioDefault1"
}, " Yes ", -1 /* HOISTED */))
const _hoisted_9 = { class: "form-check custom-radio mt-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexRadioDefault2"
}, " No ", -1 /* HOISTED */))
const _hoisted_11 = {
  key: 0,
  class: "mt-4 ms-4 border-top border-top-3"
}
const _hoisted_12 = { class: "form-check custom-checkbox mt-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "advance_care"
}, "Advance Care Plan ", -1 /* HOISTED */))
const _hoisted_14 = {
  key: 0,
  class: "ms-4"
}
const _hoisted_15 = ["id", "value", "onChange", "checked"]
const _hoisted_16 = ["for"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  id: "Name",
  for: "Name"
}, " Name ", -1 /* HOISTED */))
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  id: "Relationship",
  for: "Relationship"
}, " Relationship ", -1 /* HOISTED */))
const _hoisted_22 = {
  key: 1,
  class: "form-group"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  id: "Name",
  for: "Name"
}, null, -1 /* HOISTED */))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  id: "Name",
  name: "name",
  class: "form-control",
  type: "text"
}, null, -1 /* HOISTED */))
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = { class: "mt-4" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " If any of the following information is documented in the patient's advanced plan of care, please specify below. ", -1 /* HOISTED */))
const _hoisted_28 = { class: "form-group" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  id: "Medical Treatment Preferences",
  for: "Medical Treatment Preferences"
}, "Medical Treatment Preferences ", -1 /* HOISTED */))
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  id: "Enter Mental Health/Behavioral Treatment Preferences",
  for: "Enter Mental Health/Behavioral Treatment Preferences"
}, "Enter Mental Health/Behavioral Treatment Preferences ", -1 /* HOISTED */))
const _hoisted_32 = { class: "form-group" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  id: "Enter Cultural/Social Preferences",
  for: "Enter Cultural/Social Preferences"
}, "Enter Cultural/Social Preferences ", -1 /* HOISTED */))
const _hoisted_34 = { class: "form-group" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  id: "Enter Spiritual/Religious Preferences",
  for: "Enter Spiritual/Religious Preferences"
}, "Enter Spiritual/Religious Preferences ", -1 /* HOISTED */))
const _hoisted_36 = { class: "form-check custom-checkbox mt-4" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "surrogate"
}, " Surrogate Decision-Maker ", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormSection = _resolveComponent("FormSection")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Advance Care Plan/Admission",
    type: "his-section",
    "full-height": false,
    "application-id": Number(_ctx.application)
  }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("i", _hoisted_6, null, 512 /* NEED_PATCH */), [
              [_directive_tooltip, {
                                title: `Select Yes if the patient has a DNR,MPOA,living will,other legally valid document or surrogate decision-maker`,
                                placement: 'top'
                            }]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "radio",
              id: "flexRadioDefault1",
              value: true,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.referral.AdvancedDirectives.IsLegalDocumentation) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelRadio, _ctx.referral.AdvancedDirectives.IsLegalDocumentation]
            ]),
            _hoisted_8
          ]),
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              type: "radio",
              id: "flexRadioDefault2",
              value: false,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.referral.AdvancedDirectives.IsLegalDocumentation) = $event))
            }, null, 512 /* NEED_PATCH */), [
              [_vModelRadio, _ctx.referral.AdvancedDirectives.IsLegalDocumentation]
            ]),
            _hoisted_10
          ])
        ]),
        (_ctx.referral.AdvancedDirectives.IsLegalDocumentation)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  name: "advance_care",
                  id: "advance_care",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.referral.AdvancedDirectives.IsDirectiveDocumented) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, _ctx.referral.AdvancedDirectives.IsDirectiveDocumented]
                ]),
                _hoisted_13
              ]),
              (_ctx.referral.AdvancedDirectives.IsDirectiveDocumented)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.advancedCareSelectOptions, (option) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `${option.value}-${option.label}`,
                        class: "form-check flex-column mt-2"
                      }, [
                        _createElementVNode("div", null, [
                          _createElementVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            id: `${option.label}-${option.value}`,
                            value: option.value,
                            onChange: ($event: any) => (_ctx.handleCheckboxSelection(option.value)),
                            checked: 
                                        _ctx.referral.AdvancedDirectives.AdvancedDirectivesIntentsCollection.includes(
                                            option.value
                                        )
                                    
                          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_15),
                          _createElementVNode("label", {
                            class: "form-check-label",
                            for: `${option.label}-${option.value}`
                          }, _toDisplayString(option.label), 9 /* TEXT, PROPS */, _hoisted_16)
                        ]),
                        (
                                    _ctx.referral.AdvancedDirectives.AdvancedDirectivesIntentsCollection.includes(
                                        'Power of Attorney for Health'
                                    ) && option.value === 'Power of Attorney for Health'
                                )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _createElementVNode("div", _hoisted_18, [
                                _hoisted_19,
                                _withDirectives(_createElementVNode("input", {
                                  id: "Name",
                                  name: "name",
                                  class: "form-control",
                                  type: "text",
                                  placeholder: "Enter Name",
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.referral.AdvancedDirectives.AdvanceCarePlanName) = $event))
                                }, null, 512 /* NEED_PATCH */), [
                                  [_vModelText, _ctx.referral.AdvancedDirectives.AdvanceCarePlanName]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_20, [
                                _hoisted_21,
                                _withDirectives(_createElementVNode("input", {
                                  id: "Relationship",
                                  name: "Relationship",
                                  class: "form-control",
                                  type: "text",
                                  placeholder: "Enter Relationship",
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.referral.AdvancedDirectives.AdvanceCarePlanRelationship) = $event))
                                }, null, 512 /* NEED_PATCH */), [
                                  [_vModelText, _ctx.referral.AdvancedDirectives.AdvanceCarePlanRelationship]
                                ])
                              ])
                            ]))
                          : _createCommentVNode("v-if", true),
                        (
                                    _ctx.referral.AdvancedDirectives.AdvancedDirectivesIntentsCollection.includes(
                                        'Other Valid Documents'
                                    ) && option.value === 'Other Valid Documents'
                                )
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_25))
                          : _createCommentVNode("v-if", true)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */)),
                    _createElementVNode("div", _hoisted_26, [
                      _hoisted_27,
                      _createElementVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _withDirectives(_createElementVNode("input", {
                          id: "Medical Treatment Preferences",
                          name: "Medical Treatment Preferences",
                          class: "form-control",
                          type: "text",
                          placeholder: "Enter Medical Treatment Preferences",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.referral.AdvancedDirectives.AdvancedDirectivesPreferenceMedical) = $event))
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelText, _ctx.referral.AdvancedDirectives.AdvancedDirectivesPreferenceMedical]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _hoisted_31,
                        _withDirectives(_createElementVNode("input", {
                          id: "Enter Mental Health/Behavioral Treatment Preferences",
                          name: "Enter Mental Health/Behavioral Treatment Preferences",
                          class: "form-control",
                          type: "text",
                          placeholder: "Enter Mental Health/Behavioral Treatment Preferences",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.referral.AdvancedDirectives.AdvancedDirectivesPreferenceMental) = $event))
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelText, _ctx.referral.AdvancedDirectives.AdvancedDirectivesPreferenceMental]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _hoisted_33,
                        _withDirectives(_createElementVNode("input", {
                          id: "Enter Cultural/Social Preferences",
                          name: "Enter Cultural/Social Preferences",
                          class: "form-control",
                          type: "text",
                          placeholder: "Enter Cultural/Social Preferences",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.referral.AdvancedDirectives.AdvancedDirectivesPreferenceCultural) = $event))
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelText, _ctx.referral.AdvancedDirectives.AdvancedDirectivesPreferenceCultural]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _hoisted_35,
                        _withDirectives(_createElementVNode("input", {
                          id: "Enter Spiritual/Religious Preferences",
                          name: "Enter Spiritual/Religious Preferences",
                          class: "form-control",
                          type: "text",
                          placeholder: "Enter Spiritual/Religious Preferences",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.referral.AdvancedDirectives.AdvancedDirectivesPreferenceSpiritual) = $event))
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelText, _ctx.referral.AdvancedDirectives.AdvancedDirectivesPreferenceSpiritual]
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_36, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  name: "surrogate",
                  id: "surrogate",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.referral.AdvancedDirectives.IsSurrogateDocumented) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelCheckbox, _ctx.referral.AdvancedDirectives.IsSurrogateDocumented]
                ]),
                _hoisted_37
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}